export default __webpack_public_path__ + "static/media/skill development-09.9fbf931a.png";